import { useTranslation } from "react-i18next";
import type { AnalyticsLiveKpis, AnalyticsSnapshotResponse } from "@/features/admin/adminAnalytics.types";
import { GenericAnalyticsTab } from "@/features/admin/components/analytics/GenericAnalyticsTab";
import { GaugeBar } from "@/features/admin/components/analytics/MetricCharts";

export function AiUsageCostAnalyticsTab({
  liveKPIs,
  loading,
  snapshot,
}: {
  liveKPIs: AnalyticsLiveKpis | null;
  loading?: boolean;
  snapshot: AnalyticsSnapshotResponse | null;
}) {
  const { t } = useTranslation();
  return (
    <div className="space-y-4">
      <section className="rounded-[1.45rem] border border-white/10 bg-black/20 p-4">
        <div className="flex items-center justify-between gap-4">
          <div>
            <h3 className="text-sm font-semibold text-[#fff7ef]">{t("adminWorkspace.analytics.ai.budget")}</h3>
            <p className="mt-2 text-xs text-[#d7cab9]/70">
              {liveKPIs ? `${liveKPIs.aiBudgetStatus.percent.toFixed(1)}%` : t("adminWorkspace.analytics.neverLoaded")}
            </p>
          </div>
          <div className="w-64 max-w-full">
            <GaugeBar percent={liveKPIs?.aiBudgetStatus.percent ?? 0} />
          </div>
        </div>
      </section>
      <GenericAnalyticsTab
        loading={loading}
        panels={[
          { chart: "bar", metricKey: "credits_consumed_by_feature", series: ["continuation_suggestion", "continuity_review", "ai_chat", "timeline_summary", "image_generation", "structural_analysis", "story_import", "enhance_selection", "polish_chapter"], title: t("adminWorkspace.analytics.ai.creditsByFeature") },
          { chart: "bar", metricKey: "ai_cost_usd_by_feature", series: ["continuation_suggestion", "continuity_review", "ai_chat", "image_generation", "story_import", "enhance_selection", "polish_chapter"], title: t("adminWorkspace.analytics.ai.costByFeature") },
          { chart: "bar", metricKey: "failed_ai_calls_by_feature", series: ["continuation_suggestion", "continuity_review", "ai_chat", "image_generation", "story_import", "enhance_selection", "polish_chapter"], title: t("adminWorkspace.analytics.ai.failedCalls") },
        ]}
        snapshot={snapshot}
      />
    </div>
  );
}
